export const packageTierActionTypes = {
    STORE_PACKAGE_TIERS: 'STORE_PACKAGE_TIERS',
    CLEAR_PACKAGE_TIERS: 'CLEAR_PACKAGE_TIERS',
} as const;
